<template>
    <div class="main-container">
        <div class="sidebar-wrapper" :style="{height: scrollWrapperHeight}">
            <div class="sidebar-container">
                <el-menu  mode="vertical" >
                    <div>
                        <ul class="side-item-container">
                            <li>
                                <router-link class="side-item" to="dataAccounting">
                                    <span class="side-item__name">平台数据统计</span>
                                </router-link>
                            </li>
                            <li>
                                <router-link class="side-item" to="videoAccounting">
                                    <span class="side-item__name">按视频统计</span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </el-menu>
            </div>
        </div><div class="app-main" :style="{height: scrollWrapperHeight}">
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>
    </div>
</template>

<script>

    export default {
        name: "LowerLayout",
        data: function() {
            return {
                scrollWrapperHeight: 0
            }
        },
        computed: {
        },
        watch: {

        },
        created() {
            // this.navbar = this.$route.path.match(/^\/main\/(.*?)($|\/)/)[1];
        },
        mounted() {
            this.scrollWrapperHeight = `${window.innerHeight - 90}px`;
        },
        methods: {

        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin.scss";

    @include reset-global;

    .main-container {
        @include clearfix;
        position: relative;
        height: 100%;
        &.hideSidebar {
            .sidebar-wrapper {
                transform: translate(-140px, 0);
                .sidebar-container {
                    transform: translate(132px, 0);
                }
                &:hover {
                    transform: translate(0, 0);
                    .sidebar-container {
                        transform: translate(0, 0);
                    }
                }
            }
        }
        .sidebar-wrapper {
            width: 12%;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            z-index: 1;
            float: left;
            overflow-x: hidden;
            transition: all .28s ease-out;
            @include scrollBar;
        }
        .sidebar-container {
            transition: all .28s ease-out;
        }
        .app-main {
            width: 88%;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            float: left;
            overflow-x: hidden;
            margin-left: 12%;
        }
    }
    ul {
        padding: 0;
    }

    .el-menu {
        min-height: 100%;
    }

    .wscn-icon {
        margin-right: 10px;
    }

    .hideSidebar .menu-indent {
        display: block;
        text-indent: 10px;
    }

    .side-item {
        display: block;
        height: 56px;
        line-height: 56px;
        font-size: 14px;
        color: #48576a;
        padding: 0 20px;
        cursor: pointer;
        position: relative;
        transition: border-color .3s, background-color .3s, color .3s;
        box-sizing: border-box;
        white-space: nowrap;
        .side-item__name, .side-item__icon {
            vertical-align: middle;
        }
        &:hover {
            background-color: #d1dbe5;
        }
    }
    .side-item--sub {
        padding-left: 40px;
    }
    .side-item {
        text-decoration: none;
    }
    .router-link-active {
        color: #20a0ff;
    }
</style>



// WEBPACK FOOTER //
// src/views/accounting/accountingSidebar.vue